/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbServiceTutelleCodePostalDto
 */
export interface FcbServiceTutelleCodePostalDto {
    /**
     * 
     * @type {number}
     * @memberof FcbServiceTutelleCodePostalDto
     */
    idserviceTutelle?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FcbServiceTutelleCodePostalDto
     */
    idcodePostaux?: Array<number> | null;
}

/**
 * Check if a given object implements the FcbServiceTutelleCodePostalDto interface.
 */
export function instanceOfFcbServiceTutelleCodePostalDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbServiceTutelleCodePostalDtoFromJSON(json: any): FcbServiceTutelleCodePostalDto {
    return FcbServiceTutelleCodePostalDtoFromJSONTyped(json, false);
}

export function FcbServiceTutelleCodePostalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbServiceTutelleCodePostalDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idserviceTutelle': !exists(json, 'idserviceTutelle') ? undefined : json['idserviceTutelle'],
        'idcodePostaux': !exists(json, 'idcodePostaux') ? undefined : json['idcodePostaux'],
    };
}

export function FcbServiceTutelleCodePostalDtoToJSON(value?: FcbServiceTutelleCodePostalDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idserviceTutelle': value.idserviceTutelle,
        'idcodePostaux': value.idcodePostaux,
    };
}

